module.exports = __webpack_public_path__ + "static/oct-event.cc2c158d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHome/images/oct-event.png
// module id = 183
// module chunks = 168707334958949